<template>
  <div
    class="modal fade"
    :id="this.id || 'shared-popup'"
    ref="sharedPopup"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    data-bs-focus="false"
  >
    <div :class="modalSizeClass">
      <div class="modal-content">
        <div :class="modalBodyClass">
          <button
            ref="openButton"
            type="button"
            class="btn invisible"
            data-bs-toggle="modal"
            :data-bs-target="`#${this.id || 'shared-popup'}`"
          />
          <button
            ref="closeButton"
            type="button"
            class="btn invisible"
            data-bs-dismiss="modal"
            :data-bs-target="`#${this.id || 'shared-popup'}`"
          />
          <slot name="body" :key="slotKey" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    popupTitle: String,
    size: String,
    id: String,
    content: Object,
    modalBodyClass: {
      type: String,
      default: "modal-body"
    }
  },
  data() {
    return {
      modelElement: null,
      slotKey: 0
    };
  },
  computed: {
    modalSizeClass() {
      const c = "modal-dialog modal-dialog-centered ";
      switch (this.size) {
        case "xxl":
          return c + "modal-xxl";
        case "xl":
          return c + "modal-xl";
        case "lg":
          return c + "modal-lg";
        case "md":
          return c + "modal-md";
        case "sm":
          return c + "modal-sm";
        default:
          return c + "modal-sm";
      }
    }
  },
  mounted() {
    this.modelElement = this.$refs.sharedPopup;
    this.modelElement.addEventListener("show.bs.modal", (e) => {
      window.showModal = true;     
      this.$emit("popupOpen", e);
    });
    this.modelElement.addEventListener("hide.bs.modal", (e) => {
      window.showModal = false;
      this.$emit("popupClose", e);
    });
  },
  methods: {
    open() {
      this.slotKey++;
      this.$refs.openButton.click();
    },
    close() {
      this.$refs.closeButton.click();
    }
  }
};
</script>
